import fundSubscriberProfile from "./fundSubscriberProfile";
import ConnectToWallet from "./connectToWallet";
import Edit_profile from "./Edit_profile";
import Edit_Admin_profile from "./Edit_Admin_profile";
import adminProfile from "./adminProfile";
import providerProfile from "./providerProfile";

const profile = {
  fundSubscriberProfile,
  ConnectToWallet,
  Edit_profile,
  adminProfile,
  Edit_Admin_profile,
  providerProfile,
};
export default profile;
